import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AdminAuthProvider } from './contexts/AdminAuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminProtectedRoute from './components/AdminProtectedRoute';

// Public Pages
import HomePage from './pages/HomePage';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import FirstAccess from './pages/FirstAccess';
import ForceChangePassword from './pages/ForceChangePassword';

// Client Dashboard
import DashboardLayout from './pages/DashboardLayout';
import Dashboard from './pages/Dashboard';
import Documents from './pages/Documents';
import Contracts from './pages/Contracts';
import Profile from './pages/Profile';
import Notifications from './pages/Notifications';

// Admin Pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminForgotPassword from './pages/admin/AdminForgotPassword';
import AdminResetPassword from './pages/admin/AdminResetPassword';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import ClientList from './pages/admin/ClientList';
import ClientForm from './pages/admin/ClientForm';
import ClientDetail from './pages/admin/ClientDetail';
import ClientEdit from './pages/admin/ClientEdit';
import DocumentList from './pages/admin/DocumentList';
import ContractList from './pages/admin/ContractList';
import ContractForm from './pages/admin/ContractForm';
import ContractDetail from './pages/admin/ContractDetail';
import SalesKanban from './pages/admin/SalesKanban';
import AdminList from './pages/admin/AdminList';
import AdminForm from './pages/admin/AdminForm';
import AdminSettings from './pages/admin/AdminSettings';
import NotificationForm from './pages/admin/NotificationForm';
import FinancialReports from './pages/admin/FinancialReports';
import Expenses from './pages/admin/Expenses';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <AdminAuthProvider>
        <Router>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/primeiro-acesso" element={<FirstAccess />} />
            <Route path="/alterar-senha" element={<ForceChangePassword />} />

            {/* Client Protected Routes */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="documents" element={<Documents />} />
              <Route path="contracts" element={<Contracts />} />
              <Route path="profile" element={<Profile />} />
              <Route path="notifications" element={<Notifications />} />
            </Route>

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
            <Route path="/admin/reset-password" element={<AdminResetPassword />} />
            <Route
              path="/admin"
              element={
                <AdminProtectedRoute>
                  <AdminLayout />
                </AdminProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/admin/dashboard" replace />} />
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="clients" element={<ClientList />} />
              <Route path="clients/new" element={<ClientForm />} />
              <Route path="clients/:email" element={<ClientDetail />} />
              <Route path="clients/:email/edit" element={<ClientEdit />} />
              <Route path="documents" element={<DocumentList />} />
              <Route path="contracts" element={<ContractList />} />
              <Route path="contracts/new" element={<ContractForm />} />
              <Route path="contracts/:id" element={<ContractDetail />} />
              <Route path="sales" element={<SalesKanban />} />
              <Route path="admins" element={<AdminList />} />
              <Route path="admins/new" element={<AdminForm />} />
              <Route path="settings" element={<AdminSettings />} />
              <Route path="notifications/new" element={<NotificationForm />} />
              <Route path="reports" element={<FinancialReports />} />
              <Route path="expenses" element={<Expenses />} />
            </Route>

            {/* Redirect */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AdminAuthProvider>
    </AuthProvider>
  );
}

export default App;
